{
  "actions": {
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "update": "Update",
    "create": "Create"
  },
  "page": {
    "notFound": "Course not found",
    "editMode": "Edit mode",
    "viewAsStudent": "View as student"
  },
  "sectionTypes": {
    "banner": "Banner",
    "module": "Modules",
    "course": "Courses",
    "emptySpace": "Spacing"
  },
  "sidebar": {
    "removeTitle": "Remove item",
    "removeDescription": "Remove \"{{title}}\" from this course's menu?",
    "remove": "Remove",
    "edit": "Edit",
    "emptyHint": "No custom items: students see the global menu. Add items to create a menu exclusive to this course.",
    "addItem": "Add item"
  },
  "chrome": {
    "dragToReorder": "Drag to reorder",
    "hideFromStudent": "Hide from students",
    "showToStudent": "Show to students",
    "editSection": "Edit section",
    "removeSection": "Remove section"
  },
  "canvas": {
    "addSection": "Add section",
    "removeDescription": "This section will be removed from the course page.",
    "remove": "Remove",
    "emptyTitle": "Page has no sections",
    "emptyDescription": "Generate the default layout (banner + course modules) and customize it, or start by adding sections manually.",
    "generateDefault": "Generate default layout"
  },
  "bannerModal": {
    "title": "Edit Banner",
    "description": "Choose the banner type and configure its content.",
    "variant": "Banner type",
    "variantHero": "Course highlight (cover + progress + buttons)",
    "variantCustom": "Custom (image + title + button)",
    "heroHint": "Uses the course cover, title and description. Choose what to display:",
    "showCategory": "Show category",
    "showProgress": "Show progress bar",
    "showStart": "Show Start/Continue button",
    "showTrail": "Show View Path button",
    "image": "Image",
    "titleLabel": "Title",
    "titlePlaceholder": "Banner title",
    "subtitle": "Subtitle",
    "subtitlePlaceholder": "Supporting text (optional)",
    "ctaSection": "Button (optional)",
    "ctaLabel": "Button text",
    "ctaLabelPlaceholder": "Learn more",
    "ctaUrl": "Link",
    "ctaNewTab": "Open in new tab"
  },
  "emptySpaceModal": {
    "title": "Edit Spacing",
    "description": "Sets the height of the blank space between sections.",
    "height": "Height",
    "sizes": {
      "sm": "Small",
      "md": "Medium",
      "lg": "Large"
    }
  },
  "picker": {
    "sectionTitle": "Section title",
    "dragHint": "Drag the cards on the page to reorder.",
    "add": "Add",
    "noResults": "No results"
  },
  "moduleModal": {
    "title": "Edit Modules Section",
    "description": "Select modules from any course. The order is set by dragging the cards on the page.",
    "titlePlaceholder": "Modules",
    "selected": "Selected modules ({{count}})",
    "noneSelected": "No modules selected yet.",
    "addLabel": "Add module",
    "searchPlaceholder": "Search modules...",
    "lessonsCount_one": "{{count}} lesson",
    "lessonsCount_zero": "{{count}} lessons",
    "lessonsCount_other": "{{count}} lessons",
    "coursesCount_one": "{{count}} course",
    "coursesCount_zero": "{{count}} courses",
    "coursesCount_other": "{{count}} courses",
    "noneAvailable": "No modules available"
  },
  "courseModal": {
    "title": "Edit Courses Section",
    "description": "Select other courses to promote in this section. The order is set by dragging the cards on the page.",
    "titlePlaceholder": "Related courses",
    "selected": "Selected courses ({{count}})",
    "noneSelected": "No courses selected yet.",
    "addLabel": "Add course",
    "searchPlaceholder": "Search courses...",
    "noneAvailable": "No courses available"
  },
  "menuItemModal": {
    "title": "Menu item",
    "description": "Configure a sidebar item for this course.",
    "text": "Text *",
    "textPlaceholder": "E.g.: Community",
    "link": "Link",
    "linkPlaceholder": "/community or https://...",
    "icon": "Icon",
    "external": "External link",
    "newTab": "Open in new tab"
  },
  "menuItemForm": {
    "titleRequired": "Title is required",
    "editTitle": "Edit Menu Item",
    "newTitle": "New Menu Item",
    "editDescription": "Update the item details",
    "newDescription": "Add a new link to the student menu",
    "titleLabel": "Title *",
    "titlePlaceholder": "E.g.: Community, Support, Blog...",
    "icon": "Icon",
    "iconPlaceholder": "Select an icon",
    "linkType": "Link Type",
    "manualUrl": "Manual URL",
    "linkToCourse": "Link to Course",
    "url": "URL",
    "urlExternalPlaceholder": "https://example.com",
    "urlInternalPlaceholder": "/page",
    "selectCourse": "Select Course",
    "searchCourse": "Search course...",
    "noCourses": "No courses found",
    "external": "External link",
    "newTab": "Open in new tab",
    "active": "Active item",
    "create": "Create Item",
    "icons": {
      "globe": "Globe (Web)",
      "externalLink": "External Link",
      "chat": "Chat",
      "help": "Help",
      "document": "Document",
      "video": "Video",
      "music": "Music",
      "image": "Image",
      "calendar": "Calendar",
      "email": "Email",
      "phone": "Phone",
      "location": "Location",
      "store": "Store",
      "favorite": "Favorite",
      "featured": "Featured",
      "quickAction": "Quick Action",
      "course": "Course",
      "community": "Community",
      "gift": "Gift",
      "announcement": "Announcement"
    }
  },
  "bannerForm": {
    "imageRequired": "Image is required",
    "editTitle": "Edit Banner",
    "newTitle": "New Banner",
    "editDescription": "Update the banner details",
    "newDescription": "Add a new banner to the platform",
    "image": "Banner Image *",
    "titleLabel": "Title (optional)",
    "titlePlaceholder": "E.g.: Summer Sale",
    "linkLabel": "Destination link (optional)",
    "linkPlaceholder": "E.g.: /courses or https://...",
    "position": "Position",
    "positions": {
      "home": "Home (Dashboard)",
      "sidebar": "Sidebar",
      "header": "Header (Top)"
    },
    "active": "Active banner",
    "create": "Create Banner"
  },
  "sectionForm": {
    "titleMin": "Title must be at least 3 characters",
    "updateSuccess": "Section updated successfully",
    "createSuccess": "Section created successfully",
    "saveError": "Error saving section",
    "editTitle": "Edit Section",
    "newTitle": "New Section",
    "description": "Configure the section details",
    "titleLabel": "Title *",
    "titlePlaceholder": "E.g.: PHASE 01 - The Call of the Force",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Section description (optional)",
    "backgroundColor": "Background Color",
    "backgroundColorHint": "Custom background color for this section (optional)",
    "visible": "Visible",
    "visibleHint": "Show this section to students"
  },
  "sectionManagement": {
    "deleteTitle": "Delete section",
    "deleteDescription": "Delete this section? The products will not be deleted.",
    "delete": "Delete",
    "deleteSuccess": "Section deleted successfully",
    "deleteError": "Error deleting section",
    "hiddenSuccess": "Section hidden",
    "visibleSuccess": "Section visible",
    "visibilityError": "Error updating visibility",
    "title": "Course Sections",
    "subtitle": "Organize courses into horizontal Netflix/Xtreed-style sections",
    "newSection": "New Section",
    "hidden": "Hidden",
    "productsCount_one": "{{count}} product",
    "productsCount_zero": "{{count}} products",
    "productsCount_other": "{{count}} products",
    "hide": "Hide",
    "show": "Show",
    "emptyTitle": "No sections created",
    "emptyDescription": "Create sections to organize courses (e.g.: PHASE 01, PHASE 02)",
    "createFirst": "Create First Section"
  },
  "toasts": {
    "createMenuItemError": "Error creating menu item",
    "createSectionError": "Error creating section",
    "deleteMenuItemError": "Error removing menu item",
    "deleteSectionError": "Error removing section",
    "reorderMenuError": "Error reordering menu",
    "reorderSectionsError": "Error reordering sections",
    "updateMenuItemError": "Error updating menu item",
    "updateSectionError": "Error updating section"
  }
}
